// Right-to-left language detection for source viewer panes.
// Codes are lowercased ISO-639-1/2 plus the project's "pe" alias for Persian.
const RTL_LANGUAGE_CODES = new Set([
    'ar', // Arabic
    'fa', 'pe', // Persian / Farsi (pe = project alias)
    'he', 'iw', // Hebrew (iw = legacy code)
    'ur', // Urdu
    'ps', // Pashto
    'sd', // Sindhi
    'ug', // Uyghur
    'yi', // Yiddish
    'dv', // Divehi
    'ckb', // Central Kurdish (Sorani)
]);

/** True when a language code renders right-to-left. */
export function isRtlLanguage(code) {
    if (!code || typeof code !== 'string') return false;
    const normalized = code.trim().toLowerCase().split(/[-_]/)[0];
    return RTL_LANGUAGE_CODES.has(normalized) || RTL_LANGUAGE_CODES.has(code.trim().toLowerCase());
}

/** Returns 'rtl' or 'ltr' for a language code. */
export function languageDirection(code) {
    return isRtlLanguage(code) ? 'rtl' : 'ltr';
}
